import { Injectable } from '@angular/core';
import { NotificationToastrService } from './notification-toastr.service';
import { ErrorDto } from '@app/core/model/common/error.dto';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private notificationToastrService: NotificationToastrService) {}

  handleError(err: any): void {
    // Log the actual error details for debugging purposes
    console.error('Backend error details:', {
      status: err?.status,
      statusText: err?.statusText,
      message: err?.error?.status?.message,
      errors: err?.error?.errors,
      url: err?.url
    });
    
    // Extract and show error messages without field names
    const mainErrorMessage = err?.error?.status?.message;
    const errors: ErrorDto[] = err?.error?.errors ?? [];

    if (errors.length > 0) {
      // Show each error message without the field name
      errors.forEach(error => {
        if (error.message) {
          this.notificationToastrService.error(error.message);
        }
      });
    } else if (mainErrorMessage) {
      // Show main error message if no specific field errors
      this.notificationToastrService.error(mainErrorMessage);
    } else {
      // Fallback generic message
      this.notificationToastrService.error('Error en la operación. Inténtelo de nuevo.');
    }
  }
}
